import dayjs from 'dayjs';

import { useTranslation } from 'react-i18next';

import Typography from 'components/global/Typography';

const DurationViewer = ({ value }) => {
	const { t } = useTranslation();
	const formatDuration = (minutes) => {
		if (minutes === null || isNaN(minutes)) return '';
		const isNegative = minutes < 0;
		const absMinutes = Math.abs(minutes);
		const duration = dayjs.duration(absMinutes, 'minutes');
		const days = duration.days();
		const hours = duration.hours();
		const mins = duration.minutes();
		const parts = [];
		if (days > 0) parts.push(`${days} ${t('abbreviations.days')}`);
		if (hours > 0) parts.push(`${hours} ${t('abbreviations.hours')}`);
		if (mins > 0 || parts.length === 0) parts.push(`${mins} ${t('abbreviations.minutes')}`);
		const result = parts.join(' ');
		return isNegative ? `-${result}` : result;
	};

	return <Typography>{value && formatDuration(value)}</Typography>;
};

export default DurationViewer;
